import { dayjs } from "@/core/utils/date";

export const AP_STALE_TIME = 60 * 1000;

const INVOICE_UPLOAD_BOOST_WINDOW_MS = 2 * 60 * 1000;
let lastInvoiceUploadAt: ReturnType<typeof dayjs> | null = null;

export const markInvoiceUpload = () => {
  lastInvoiceUploadAt = dayjs();
};

const isDeepList = (query: { state: { data?: { pages: unknown[] } } }) =>
  (query.state.data?.pages.length ?? 0) > 2;

const invoiceUploadIsRecent = () =>
  lastInvoiceUploadAt !== null &&
  dayjs().diff(lastInvoiceUploadAt) < INVOICE_UPLOAD_BOOST_WINDOW_MS;

export const apListRefetchInterval = (query: {
  state: { data?: { pages: unknown[] } };
}) => (isDeepList(query) ? false : AP_STALE_TIME);

export const apInvoiceListRefetchInterval = (query: {
  state: { data?: { pages: unknown[] } };
}) => (isDeepList(query) && !invoiceUploadIsRecent() ? false : AP_STALE_TIME);
